import { toast } from 'react-toastify'
import { all, put, select, takeEvery } from 'redux-saga/effects'

import { request } from '../../../1stlog-ui/src/utils'
import { receiveOrder, requestOrder } from './actions'
import { CANCEL_COLI, REQUEST_ORDER } from './constants'
import { makeSelectOrder } from './selectors'

export default function* root() {
  yield all([
    takeEvery(CANCEL_COLI, handleColiCancel),
    takeEvery(REQUEST_ORDER, handleRequestOrder),
  ])
}

function* handleColiCancel({ payload }) {
  try {
    const result = yield request({
      method: 'get',
      url: `/api/orderlisting/cancel/${payload}`,
    })

    if (result.data === 'success') {
      const order = yield select(makeSelectOrder())

      yield put(requestOrder(order.id))
    }
  } catch (error) {
    console.error(error)
    toast.error('Stornierung fehlgeschlagen! Bitte erneut versuchen.')
    yield put(receiveCancelColi({ error: error }))
  }
}

function* handleRequestOrder({ payload }) {
  try {
    const result = yield request({
      method: 'get',
      url: `/api/orderlisting/${payload}`,
    })
    // console.log(receiveOrder)
    yield put(receiveOrder({ result: result.data }))
  } catch (error) {
    yield put(receiveOrder({ error }))
  }
}
